import React, {Component} from 'react';
import {Label, UncontrolledTooltip} from 'reactstrap';
import Select from "../../local_node_modules/react-select"
import '../../local_node_modules/react-select/dist/react-select.css';
import Swal from 'sweetalert2';
import _ from 'lodash';

import moment from 'moment';
import Datetime from 'react-datetime';
import NumberFormat from 'react-number-format';
import {Decimal} from 'decimal.js';
import {deepCopyObject, hasUserRight, showAxiosError} from "../../helper/helper";
import VoucherLines from "./component/VoucherLines";
import NoteList from "./component/NoteList";
import TotalList from "./component/TotalList";
import ExternalCustomer from "./component/ExternalCustomer";
import Alert from "react-s-alert";
import 'react-datetime/css/react-datetime.css';
import 'moment/locale/tr';
import {validateField} from "../../common/validation";
import {request} from "../../helper/APIUtils";
import {isValidVoucher} from "../../common/componentValidation";
import ReactLoadingTop from "../../components/ReactLoadingTop";
import NavBarKS from "../../components/NavBarKS";
import StickButton from "../../components/StickButton";
import MediaViewer from "../einvoice/MediaViewer";
import DefaultModal from "../invoice/DefaultModal";
import {showBarStandartVouchers, showCalculateVoucherBtn, showBaro, showSmmRepeatDay} from "../../helper/permission";
import {DocumentFrom, EntegratorIdentifiers, UserRightsEnum} from "../../helper/enums";
import ForeignCompanyInfo from "../invoice/component/ForeignCompanyInfo";
import cacheInstance from "../../components/cache/Cache";
import Payment from "../invoice/component/Payment";
import {Accordion, AccordionItem, AccordionItemBody, AccordionItemTitle} from "react-accessible-accordion";
import ExchangeDocumentInfo from "./component/ExchangeDocumentInfo";
import ConnectorExternalCustomer from "../invoice/component/ConnectorExternalCustomer";
import {uuidGenerator} from "../connector/erpHelper";
import {VirtualHost} from "../../constants";
import NoIdentifier from "../invoice/component/NoIdentifier";
import {EntegratorConf} from "../../constants";


class CreateEditVoucher extends Component {
	constructor(props) {
		super(props);
		this.state = {
			error:{},
			saveLoading:false,
			saveType: "saveClose",
			manual:false,
			repeat:false,
			changeDate:false,
			barStandardVoucherContent:[],
            showCalculateVoucherBtn: showCalculateVoucherBtn()
		};

		this.setExternalCustomer   = this.setExternalCustomer.bind(this);
		this.setTrdDocVoucherLines = this.setTrdDocVoucherLines.bind(this);
		this.setTrdDocVoucherNotes = this.setTrdDocVoucherNotes.bind(this);
		this.onClickSave  		   = this.onClickSave.bind(this);
		this.validateField 		   = this.validateField.bind(this);
		this.errorListener 		   = this.errorListener.bind(this);
		this.getXSLT 		   	   = this.getXSLT.bind(this);
		this.isManual 		   	   = this.isManual.bind(this);
		this.onChangeValue 		   = this.onChangeValue.bind(this);
		this.saveDocument 		   = this.saveDocument.bind(this);
		this.getInitVoucher 	   = this.getInitVoucher.bind(this);
		this.sendIncorrectVoucher  = this.sendIncorrectVoucher.bind(this);
		this.showDocument          = this.showDocument.bind(this);
		this.setMediaViewer        = this.setMediaViewer.bind(this);
		this.confirmSend		   = this.confirmSend.bind(this);
		this.handleSend			   = this.handleSend.bind(this);
		this.fetchVoucher		   = this.fetchVoucher.bind(this);
		this.fetchBarStandardVouchers = this.fetchBarStandardVouchers.bind(this);
		this.setDocForeignCustomer = this.setDocForeignCustomer.bind(this);
		this.onChangeValue         = this.onChangeValue.bind(this);
		this.checkUserRights 	   = this.checkUserRights.bind(this);
		this.setPaymentInfo 	   = this.setPaymentInfo.bind(this);
		this.clearPaymentInfo 	   = this.clearPaymentInfo.bind(this);
		this.isKamu 	           = this.isKamu.bind(this);
		this.setAdditionalDocument = this.setAdditionalDocument.bind(this);
		this.changeKDV 			   = this.changeKDV.bind(this);
		this.setChangeDate 		   = this.setChangeDate.bind(this);
		this.onChangeDateAndCurrency = this.onChangeDateAndCurrency.bind(this);
	}

	componentDidMount() {
		this.checkUserRights();
		this.fetchVoucher();
        if(this.props.match.params.type === 'SMM' && this.state.showCalculateVoucherBtn  && showBarStandartVouchers()){
            this.fetchBarStandardVouchers();
        }
		if(hasUserRight(UserRightsEnum.ekonnektor.view,this.props.currentUser)){
			this.getConnectionInfo();
		}
	}
	getConnectionInfo = async()=>{
		let self = this;
		let params = {
			url: `/connector/getConnectionInfo`,
			method: "post"
		};
		try{
			let {data} = await request(params);
			if(data!=null){
				self.setState({connectionInfo:data});
			}
		}catch(error){
			//let err = {response:{data:"Konnektör Bulunamadı"}}
			//showAxiosError(err);
		}
	}
	checkUserRights(){
		if (((this.props.match.params.recordId ==="0" && this.props.match.params.type==="MM" && !hasUserRight(UserRightsEnum.voucher.mmCreate,this.props.currentUser))
			|| (this.props.match.params.recordId ==="0" && this.props.match.params.type==="SMM" && !hasUserRight(UserRightsEnum.voucher.smmCreate,this.props.currentUser))
			|| (this.props.match.params.recordId ==="0" && this.props.match.params.type==="EXCHANGE" && !hasUserRight(UserRightsEnum.exchange.create,this.props.currentUser))
			|| (this.props.match.params.recordId !=="0" && this.props.match.params.type==="MM" && !hasUserRight(UserRightsEnum.voucher.mmUpdate,this.props.currentUser))
			|| (this.props.match.params.recordId !=="0" && this.props.match.params.type==="SMM" && !hasUserRight(UserRightsEnum.voucher.smmUpdate,this.props.currentUser))
			|| (this.props.match.params.recordId !=="0" && this.props.match.params.type==="EXCHANGE" && !hasUserRight(UserRightsEnum.exchange.update,this.props.currentUser))) && false){
			this.props.history.push("/");
		}
	}


	fetchVoucher(){
		let self = this;
		let match= this.props.match;
		let params = {url:`/voucher${match.params.direction}/edit/${match.params.type}/${match.params.recordId}`,
			method:"post",
		};
		request(params)
			.then(response => {
				let data = response.data.trdDocVoucher;
				if (!data.externalCustomer) {
					data.externalCustomer = {
						commerceChamber: null,
						customer: null,
						externalCustomerAddressList: [],
						familyName: null,
						formattedName: null,
						givenName: null,
						mersisNumber: null,
						middleName: null,
						recordId: null,
						taxOffice: null,
						title: null,
						tradeRegistrationNumber: null,
						vknTckn: null,
						isForeignCustomer: false,
					};
				}
				if (!data.externalCustomerAddress) {
					data.externalCustomerAddress = {
						buildingName: null,
						buildingNo: null,
						cityName: null,
						citySubdivisionName: null,
						countryName: null,
						email: null,
						fax: null,
						postalAddressRegion: null,
						postalAddressRoom: null,
						postalZone: null,
						postboxAlias: null,
						recordId: null,
						streetName: null,
						telephone: null,
						webSite: null
					};
				}

				self.setState({
					data: data,
					initData: deepCopyObject(response.data.trdDocVoucher),
					charges: response.data.charges,
					xslts: response.data.xslts,
					cities: response.data.cities,
					withholdingTypes: response.data.withholdingTypes,
					stoppageTypes: response.data.stoppageTypes,
					countries: response.data.countries,
					unitCodes: response.data.unitCodes,
					currencyCodes: response.data.currencyCodes,
					suffix: (response.data.currencyCodes).find(x => x.shortCode === response.data.trdDocVoucher.documentCurrencyCode).symbol,
				});
				if (match.params.type === "EXCHANGE"){
					self.setState({
						paymentMeansCodes: response.data.paymentMeansCodes,
						paymentChannelCodes: response.data.paymentChannelCodes
					})
				}

			})
			.catch(function (error) {
				showAxiosError(error);
			});

	}

	fetchBarStandardVouchers(){
		let self = this;
		let params = {
			url: `/voucherTmp/getESmmPriceList`,
			method: 'post'
		};
		self.setState({loading: true});
		request(params)
			.then(function (response) {
				self.setState({loading: false, barStandardVoucherContent:response.data});
			}).catch(function (error) {
			self.setState({loading: false});
			showAxiosError(error);
		});
	}

	onChangeCurrency(e, label) {
		let data = deepCopyObject(this.state.data);
        let self = this;
        data["documentCurrencyCode"] = e.value;
		if (data["documentCurrencyCode"] === "TRY") {
            this.setState({data ,
                                suffix: (self.state.currencyCodes).find(x => x.shortCode === data['documentCurrencyCode']).symbol,
                                manual:true});
			return;
		}
		let issueDate = moment(this.state.data.issueDate).format("YYYY-MM-DD");
		let options = {
			code: e.value,
			date: issueDate
		};
		let params = {
			url: `/common/getCurrencyValue/${options.code}/${options.date}`,
			method: "post",
		};
		request(params)
		.then(response => {
			let forex = response.data;
			data['paymentExchangeRate'] = forex[label];
			self.setState({
				forex: forex,
				data: data,
				suffix: (self.state.currencyCodes).find(x => x.shortCode === data['documentCurrencyCode']).symbol,
                manual: true
			});
		})
		.catch(function (error) {
			let forex = {ForexSelling: "0.00", ForexBuying: "0.00"};
			data['paymentExchangeRate'] = forex[label];
			self.setState({
				forex: forex,
				data: data,
				suffix: (self.state.currencyCodes).find(x => x.shortCode === data['documentCurrencyCode']).symbol
			});
			showAxiosError(error);
		});
	}

	onChange(e, label) {
		if(label === "ForexBuying" ){
			this.setState({forexType:"Alış"});
		}else{
			this.setState({forexType:"Satış"});
		}

		let data = deepCopyObject(this.state.data);
		if (data.forex === undefined || data.forex[label] === undefined) {
			this.onChangeCurrency({value: data.documentCurrencyCode}, label);
		} else {
            data['paymentExchangeRate'] = this.state.forex[label];
			this.setState({data, manual:true});
		}
	}

	onChangeValue(e) {
		let data = deepCopyObject(this.state.data);
		const {name, value} = e;
		if (name === "retailCustomer") {
			if (value) {
				//data.externalCustomer = {};
				//data.externalCustomerAddress = {};
			} else {
				data.trdDocExternalCustomer = null;
			}
		}
		if (name === "hasForeignCustomer") {
				data.externalCustomer={
					buyerType: null,
					city: null,
					commerceChamber: null,
					customer: null,
					customerCode: null,
					customerRiskLimit: null,
					customerType: 2,
					externalCustomerAddressList: [],
					externalCustomerBankList: [],
					familyName: null,
					formattedName: null,
					givenName: null,
					initialBalance: null,
					mersisNumber: null,
					middleName: null,
					recordId: null,
					taxOffice: null,
					title: null,
					tradeRegistrationNumber: null,
					vknTckn: null};
				data.externalCustomerAddress = {
					buildingName: null,
					buildingNo: null,
					cityName: null,
					citySubdivisionName: null,
					countryName: null,
					email: null,
					fax: null,
					postalAddressRegion: null,
					postalAddressRoom: null,
					postalZone: null,
					postboxAlias: null,
					recordId: null,
					streetName: null,
					telephone: null,
					webSite: null
				};
		}
		if (e.name === "documentTypeCode" && e.value === "DOVIZSATIMBELGESI"){
			data["trdDocVoucherLines"].map(lines => {
				lines.quantity = 1;
				lines.unitPrice = 1;
				lines["trdDocVoucherLineCharges"].map(charge => {
					if(charge.taxCode.code === "0021"){
						charge.percentage = 0.2;
					}
				})
			});
			data = CreateEditVoucher.calculateTotal(data);
			data[name] = value;
			this.setState({data});
			this.setState({changeDate:true});
		} else if (e.name === "documentTypeCode" && e.value === "DOVIZALIMBELGESI"){
			data["trdDocVoucherLines"].map(lines => {
				lines.quantity = 1;
				lines.unitPrice = 1;
				lines["trdDocVoucherLineCharges"].map(charge => {
					if(charge.taxCode.code === "0021"){
						charge.percentage = 0.2;
					}
				})
			});
			data = CreateEditVoucher.calculateTotal(data);
			data[name] = value;
			this.setState({data});
			this.setState({changeDate:true});
		} else if (e.name === "documentTypeCode" && e.value === "EKIYMETLIMADENALIMBELGESI"){
			data["trdDocVoucherLines"].map(lines => {
				lines.quantity = 1;
				lines.unitPrice = 1;
				lines["trdDocVoucherLineCharges"].map(charge => {
					if(charge.taxCode.code === "0021"){
						charge.percentage = 0.2;
					}
				})
			});
			data = CreateEditVoucher.calculateTotal(data);
			data[name] = value;
			this.setState({data});
		} else if (e.name === "documentTypeCode" && e.value === "EKIYMETLIMADENSATIMBELGESI"){
			data["trdDocVoucherLines"].map(lines => {
				lines.quantity = 1;
				lines.unitPrice = 1;
				lines["trdDocVoucherLineCharges"].map(charge => {
					if(charge.taxCode.code === "0021"){
						charge.percentage = 0.2;
					}
				})
			});
			data = CreateEditVoucher.calculateTotal(data);
			data[name] = value;
			this.setState({data});
		}else{
			data[name] = (name === "paymentExchangeRate" ? (new Decimal(value)).toNumber() : value);
			this.setState({data});
		}
	}

	setDocForeignCustomer(docForeignCustomer) {
		let data = deepCopyObject(this.state.data);
		data["tmpDocVoucherForeignCustomer"] = docForeignCustomer;
		this.setState({data},()=>console.log("data",data));
	}

	onChangeDate(momentObj, name) {
		let data = deepCopyObject(this.state.data);
		if (!(typeof momentObj === "string")) {
			if (name === "date") {
				let date = momentObj.format("YYYY-MM-DD");
				let time = moment(data.issueDate).format("HH:mm:ss");
				data.issueDate = moment(date + "T" + time).format("YYYY-MM-DDTHH:mm:ss");
				this.setState({data});
			} else if (name === "time") {
				let time = momentObj.format("HH:mm:ss");
				let date = moment(data.issueDate).format("YYYY-MM-DD");
				data.issueDate = moment(date + "T" + time).format("YYYY-MM-DDTHH:mm:ss");
				this.setState({data});
			} else {
			}
		} else {
		}
	}
	async onChangeDateAndCurrency  (momentObj, name, currencyCode, forexType)  {
		this.setState({changeDate:true});
		await this.onChangeDate(momentObj, name);
		this.onChangeCurrency(currencyCode ? {value: currencyCode} : {value: "TRY"}, forexType && forexType === "Satış" ? "ForexSelling" :  "ForexBuying");
	}

	setChangeDate(){
		this.setState({changeDate:false});
	}

	setExternalCustomer(externalCustomer, externalCustomerAddress) {
		let data = deepCopyObject(this.state.data);
		data["externalCustomer"] = externalCustomer;
		data["externalCustomerAddress"] = externalCustomerAddress;
		this.setState({data});
	}

	setConnectorExternalCustomer = (externalCustomer) => {
		let data = deepCopyObject(this.state.data);
		data["tmpDocConnectorExCustomer"] = externalCustomer;
		this.setState({data});
	}

	setTrdDocVoucherLines(trdDocVoucherLines, note) {
		let data = deepCopyObject(this.state.data);
		data['trdDocVoucherLines'] = trdDocVoucherLines;
		if (this.state.data.documentTypeCode === "DOVIZSATIMBELGESI"){
			data["trdDocVoucherLines"].map(lines => {
				lines["trdDocVoucherLineCharges"].map(charge => {
					if(charge.taxCode.code === "0021"){
						charge.percentage = 0.2;
					}
				})
			});
		} else if (this.state.data.documentTypeCode === "DOVIZALIMBELGESI"){
			data["trdDocVoucherLines"].map(lines => {
				lines["trdDocVoucherLineCharges"].map(charge => {
					if(charge.taxCode.code === "0021"){
						charge.percentage = 0.2;
					}
				})
			});
		} else if (this.state.data.documentTypeCode === "EKIYMETLIMADENALIMBELGESI"){
			data["trdDocVoucherLines"].map(lines => {
				lines["trdDocVoucherLineCharges"].map(charge => {
					if(charge.taxCode.code === "0021"){
						charge.percentage = 0.2;
					}
				})
			});
		} else if (this.state.data.documentTypeCode === "EKIYMETLIMADENSATIMBELGESI"){
			data["trdDocVoucherLines"].map(lines => {
				lines["trdDocVoucherLineCharges"].map(charge => {
					if(charge.taxCode.code === "0021"){
						charge.percentage = 0.2;
					}
				})
			});
		}
		data = CreateEditVoucher.calculateTotal(data);
		if(note && data.trdDocVoucherNotes && data.trdDocVoucherNotes.length>0){
			let firstNote = data.trdDocVoucherNotes[0];
			firstNote.note = note;
			data.trdDocVoucherNotes[0] = firstNote;
			this.setState({data,manual:true});
		}else{
			this.setState({data});
		}
	}

	setTrdDocVoucherNotes(trdDocVoucherNotes) {
		let data = deepCopyObject(this.state.data);
		data['trdDocVoucherNotes'] = trdDocVoucherNotes;
		this.setState({data});
	}

	static calculateTotal(tData) {
		let data = deepCopyObject(tData);
		let trdDocVoucherLines = data.trdDocVoucherLines;
		let lineExtensionTotalAmount = new Decimal(0.00);
		let lineChargeTotalAmount = new Decimal(0.00);
		let allowanceTotalAmount = new Decimal(0.00);
		let toBeAddedTotalChargeAmount = new Decimal(0.00);
		for (let i = 0; i < trdDocVoucherLines.length; i++) {
			let trdDocVoucherLine = trdDocVoucherLines[i];
			let trdDocVoucherLineCharges = trdDocVoucherLine.trdDocVoucherLineCharges;
			lineExtensionTotalAmount = lineExtensionTotalAmount.add(new Decimal(trdDocVoucherLine.lineExtensionAmount));
			for (let j = 0; j < trdDocVoucherLineCharges.length; j++) {
				let trdDocVoucherLineCharge = trdDocVoucherLineCharges[j];
				if (trdDocVoucherLineCharge.taxCode.code === "0021"){
					trdDocVoucherLineCharge.amount = new Decimal(new Decimal(trdDocVoucherLineCharge.percentage).mul(trdDocVoucherLine.lineExtensionAmount)).div(100);
				}
				lineChargeTotalAmount = lineChargeTotalAmount.add((new Decimal(trdDocVoucherLineCharge.amount)).mul(trdDocVoucherLineCharge.direction));
				if (trdDocVoucherLineCharge.taxCode.code === "0000")
					allowanceTotalAmount = allowanceTotalAmount.add(new Decimal(trdDocVoucherLineCharge.amount));
				else {
					if (trdDocVoucherLineCharge.direction === 1) {
						toBeAddedTotalChargeAmount = toBeAddedTotalChargeAmount.add(new Decimal(trdDocVoucherLineCharge.amount));
					} else {

					}
				}
			}
		}
		data.payableAmount = new Decimal(lineExtensionTotalAmount.add(lineChargeTotalAmount).toFixed(2, (/*["mikrokom", "turkkep"].includes(VirtualHost.conf.resourcePrefix)*/["turkkep"].includes(VirtualHost.conf.resourcePrefix) ? Decimal.ROUND_UP : ("mikrokom" === VirtualHost.conf.resourcePrefix ? Decimal.ROUND_HALF_UP : Decimal.ROUND_HALF_DOWN)))).toNumber();
		if (!["mikrokom"].includes(VirtualHost.conf.resourcePrefix) && data.payableAmount.toString().split(".")[1] === "01") {
			data.payableAmount = data.payableAmount - 0.01;
		}
		data.lineExtensionAmount = new Decimal(lineExtensionTotalAmount.toFixed(2, (showBaro() ? Decimal.ROUND_HALF_DOWN : Decimal.ROUND_HALF_UP))).toNumber();
		data.allowanceTotalAmount = new Decimal(allowanceTotalAmount.toFixed(2, (showBaro() ? Decimal.ROUND_HALF_DOWN : Decimal.ROUND_HALF_UP))).toNumber();
		data.taxInclusiveAmount = new Decimal(lineExtensionTotalAmount.sub(allowanceTotalAmount).add(toBeAddedTotalChargeAmount).toFixed(2, (showBaro() ? Decimal.ROUND_HALF_DOWN : Decimal.ROUND_HALF_UP))).toNumber();
		data.taxExclusiveAmount = new Decimal(lineExtensionTotalAmount.sub(allowanceTotalAmount).toFixed(2, (showBaro() ? Decimal.ROUND_HALF_DOWN : Decimal.ROUND_HALF_UP))).toNumber();
		return data;
	}

	onClickSave(e,type) {
		e.preventDefault();
		let self = this;
		this.setState({saveLoading: true, saveType: type});
		let data = deepCopyObject(self.state.data);
		if(type === "new"){
			if(!(_.isEqual(data,self.state.initData))){
				Swal({
					title: 'Onay',
					text: 'Makbuzdaki değişiklikler kaydedilsin mi?',
					showCancelButton: true,
					confirmButtonText: 'Evet',
					cancelButtonText: 'Hayır',
					showCloseButton:true,
					onClose: () => {
						self.setState({saveLoading: false});
					}
				}).then((result) => {
					if (result.value) {
						self.saveDocument(data,type);
						Swal.close();
					} else if (result.dismiss === Swal.DismissReason.cancel) {
						Swal.close();
						self.getInitVoucher("Yeni oluşturuldu.");
					}
				});
			}else{
				this.getInitVoucher("Yeni oluşturuldu.");
			}
		}else if(type==="look") {
			this.showDocument();
		}else if(type === "save"){
			self.saveDocument(data,type);
		}else if(type === "saveClose"){
			self.saveDocument(data,type);
		}else if(type === "directSend"){
			this.saveDocument(data, type);
		}else if(type === "saveSend"){
			//Hatalı faturanın düzenlenmiş halini gönderiyoruz.
			if(data.deletedAt)
				self.sendIncorrectVoucher();
			else
				self.setState({saveLoading: false});
		}else{
			self.setState({saveLoading: false});
		}
	}

	sendIncorrectVoucher(){
		let self = this;
		let match = self.props.match;
		let item = self.state.data;
		let result = isValidVoucher(item,match.params.direction);
		let error = result.error;
		let valid = result.valid;
		if (valid) {
			let params = {
				url:`/voucherTmp/update`,
				method :'post',
				data:item
			};

			self.setState({saveLoading: true});
			request(params)
			.then(function (response) {
				cacheInstance.delete((match.params.type === "MM" ? "mVoucher" :(match.params.type === "SMM" ? "sVoucher" : "exVoucher")));
				self.setState({saveLoading: false});
				self.props.history.push(`/eVoucher${(match.params.type === "MM" ? 'M' : (match.params.type === "SMM" ? 'S' : 'E'))}`);
				Alert.closeAll();
				Alert.success("Düzenlenmiş makbuz başarılı şekilde gönderildi.", {
					position: 'top-right',
					effect: 'stackslide',
					timeout: 2000
				});
			}).catch(function (error) {
				self.setState({saveLoading: false});
				showAxiosError(error);
			});
		}else{
			Alert.error(result.errorMessage, {
				position: 'top-right',
				effect: 'stackslide',
				timeout: 8000
			});
			self.setState({error: error, saveLoading: false});
		}
	}

	setMediaViewer() {
		this.setState({url: null, mediaModal: false});
	}

	showDocument(){
		let self = this;
		let data = deepCopyObject(self.state.data);
		let match = self.props.match;
		let result = isValidVoucher(data,match.params.direction);
		let error = result.error;
		let valid = result.valid;
		let item = data;
		if (valid) {
			let params = {
				url:"/voucherTmp/showDocument",
				responseType: 'arraybuffer',
				method: 'post',
				data: data
			};
			self.setState({mediaModal: true, title: item.documentUuid});

			request(params)
				.then(response => {
					let blob = new Blob([response.data], {type: response.headers["content-type"]});
					let urlCreator = window.URL || window.webkitURL;
					let url = urlCreator.createObjectURL(blob);
					self.setState({url: url, saveLoading: false});
				})
				.catch(function (error) {
					self.setState({saveLoading: false});
					showAxiosError(error);
				});
		} else {
			Alert.error(result.errorMessage, {
				position: 'top-right',
				effect: 'stackslide',
				timeout: 8000
			});
			self.setState({
				error: error,
				saveLoading: false,
				activeTab: result.activeTab,
				hTabs: result.hTabs
			});
		}
	}

	handleSend(item) {
		let self = this;
		let params = {
			url: `/${self.props.match.params.type==="EXCHANGE" ? "exchange" : "voucherTmp"}/getPrefixCode/${item.recordId}`,
			method: 'post'
		};

		self.setState({reactLoading: true});
		request(params)
			.then(function (response) {
				let prefixCodes = response.data;
				self.setState({
					showSendSwal: true,
					prefixCodes: prefixCodes,
					documentId: prefixCodes[0].value,
					lastIssueDate: prefixCodes[0].lastIssueDate,
					item: item,
				});

			}).catch(function (error) {
			showAxiosError(error);
		}).then(function () {
			self.setState({reactLoading: false});
		});
	}

	confirmSend() {
		let self = this;
		let item = self.state.item;
		let match = self.props.match;
		let params = {
			url:`/${self.props.match.params.type==="EXCHANGE" ? "exchange" : "voucherTmp"}/send`,
			method: 'post',
			data: {
				repeat:  this.state.repeat,
				recordId: item.recordId,
				documentId: this.state.documentId,
				lastIssueDate: this.state.lastIssueDate
			}
		};

		self.setState({sendBtnDisabled: true});
		request(params)
			.then(function (response) {
				self.updateInvoiceNumberWs(item.recordId);
				self.setState({showSendSwal: false, sendBtnDisabled: false, manual: true});
				Alert.success("Gönderim başarılı şekilde gerçekleştirildi.", {
					position: 'top-right',
					effect: 'stackslide',
					timeout: 5000
				});

				cacheInstance.delete((match.params.type === "MM" ? "mVoucher" : (match.params.type === "SMM" ? "sVoucher" : "exVoucher")));

				if(match.params.direction === "Tmp") {
					self.props.history.push((match.params.type === "MM" ? "/eVoucherMT" : (match.params.type === "SMM" ? "/eVoucherST" : "/eVoucherET")));
				}
				else {
					self.props.history.push((match.params.type === "MM" ? "/mVoucher" :(match.params.type === "SMM" ? "sVoucher" : "exVoucher")) + match.params.direction);
				}
				}).catch(function (error) {
			self.setState({sendBtnDisabled: false, showSendSwal: false});
			showAxiosError(error);
		});
	}

	saveDocument(data,type){
		let self = this;
		let match = self.props.match;
		let result = isValidVoucher(data,match.params.direction);
		let error = result.error;
		let valid = result.valid;
		if(match.params.type==="EXCHANGE"){
			data["paymentInfo"]["paymentDueDate"] = moment(data["paymentInfo"]["paymentDueDate"]);
		}
		if (valid) {
			if (!data["from"]) {
				data["from"] = DocumentFrom.PORTAL;
			}

			let params = {
				url:`/voucher${match.params.direction}/save/${match.params.recordId}`,
				method:"post",
				data:data
			};
			request(params)
			.then(response => {
				let data = response.data;
				self.setState({saveLoading: false, data:data, initData: deepCopyObject(data)});
				if(type === "saveClose"){
					Alert.success('Kaydedildi', {
						position: 'top-right',
						effect: 'stackslide',
						timeout: 2000
					});
					self.setState({saveLoading:false});
					if(match.params.direction === "Tmp")
						self.props.history.push((match.params.type==="MM"? "/eVoucherMT" : (match.params.type === "SMM" ? "/eVoucherST" : "/eVoucherET")));
					else
						self.props.history.push((match.params.type==="MM"? "/mVoucher" :(match.params.type === "SMM" ? "sVoucher" : "exVoucher")) +match.params.direction);
				}else if(type ==="directSend"){
					self.handleSend(data);
				}else if(type === "new"){
					this.getInitVoucher("Kaydedildi");
				}
				if(type !== "new"){
					Alert.closeAll();
					Alert.success('Kaydedildi', {
						position: 'top-right',
						effect: 'stackslide',
						timeout: 2000
					});
				}
			})
			.catch(function (error) {
				self.setState({saveLoading: false});
				showAxiosError(error);
			});
		} else {
			Alert.error(result.errorMessage, {
				position: 'top-right',
				effect: 'stackslide',
				timeout: 8000
			});
			self.setState({error: error, saveLoading: false});
		}
	}

	handleWebsocket = () =>{
		const {connectionInfo} = this.state;
		let ip = connectionInfo.ownerIp + "/websocket/chat";
		const ws = new WebSocket(ip);
		this.setState({ws});
		ws.onopen = () => {
			console.log("connected")
		}

		ws.onmessage = evt => {
			let {queryType,rows,uuid} = JSON.parse(evt.data)
			rows = JSON.parse(rows);
			if(queryType == "ERROR" && rows && rows[0].error){
				console.log(rows[0].error);
				this.setState({searching:false})
			}else if((queryType === "UPDATE_INVOICE_NUMBER") && rows != null){
				let documentId = rows[0].documentId;
				if(documentId!=null ){
					let params = {
						url: `/connector/updateSqlHistory/invoice/${documentId}`,
						method: "post"
					};
					let {data} = request(params);
				}
			}
		}
		ws.onclose = () => {
			console.log("connected")
		}
	}

	updateInvoiceNumberWs = async (recordId) =>{
		let self = this;
		const {connectionInfo} = self.state;
		if(connectionInfo!=null && connectionInfo.connectionType === "WEBSOCKET"){
			self.handleWebsocket();
			let params = {
				url: `/connector/getUpdateSql/${recordId}/voucher`,
				method: "post"
			};
			try{
				let {data} = await request(params);
				if(data) {
					self.sendWebsocketMessage(data, "UPDATE_VOUCHER_NUMBER")
				}
			}catch(error){
				let err = {response:{data:error.toString()}}
				showAxiosError(err);
			}
		}
	}
	sendWebsocketMessage = async (query,queryType,documentUuid) =>{
		let ws = this.state.ws;
		if(ws.readyState !== 1){
			await new Promise(r => setTimeout(r, 1000));
		}
		if ( ws.readyState === 3 ) {
			ws.close();
			this.handleWebsocket();

			// wait until new connection is open
			while (ws.readyState !== 1) {
				await new Promise(r => setTimeout(r, 1000));
			}
		}
		const {connectionInfo} = this.state;
		const {currentUser} = this.props;

		let header = {
			customerId: currentUser.customerId,
			dataSource: connectionInfo.dataSource,
			initialCatalog: connectionInfo.initialCatalog,
			dbUser: connectionInfo.dbUser,
			dbPassword: connectionInfo.dbPassword,
			key: connectionInfo.key,
			branchId: connectionInfo.branchId,
			clientType:"PORTAL"
		}
		let body = {
			uuid:documentUuid?documentUuid: uuidGenerator(),
			queryType: queryType,
			query: query
		};

		let jsonMsg = JSON.stringify({header,body})
		ws.send(jsonMsg);
	}

	getInitVoucher(info){
		let self = this;
		let match = self.props.match;
		let params = {
			url: `/voucher${match.params.direction}/edit/${match.params.type}/-1`,
			method: "post"
		};
		request(params)
		.then(response => {
			Alert.closeAll();
			Alert.success(info, {
				position: 'top-right',
				effect: 'stackslide',
				timeout: 2000
			});
			let data = response.data.trdDocVoucher;
			self.setState({data: data, initData: deepCopyObject(data), saveLoading: false, manual:true });
		})
		.catch(function (error) {
			self.setState({saveLoading: false});
			showAxiosError(error);
		});
	}

	validateField(e) {
		let id = e.target.id;
		let rule = e.target.dataset.vdata;
		let boundary = e.target.dataset.vlength;
		let result = validateField(rule, boundary, e.target.value);
		let error = this.state.error;
		error = Object.assign(error, {[id]: result});
		this.setState({error});
	}

	validateClass(id) {
		let error = this.state.error;
		return (error[id] === undefined ? "" : (error[id].valid ? " has-success" : " has-danger"));
	}

	validateMessage(id) {
		let error = this.state.error;
		return (error[id] === undefined ? '' : (error[id].message));
	}

	errorListener(tError){
		let error = this.state.error;
		error = Object.assign(error, tError);
		this.setState({error});
	}

	getXSLT(){
		let xslts = this.state.xslts;
		let xslt  = xslts.find(x => x.isDefault === 1);
		if(xslt){
			this.onChangeValue({name:"xsltPath", value:(xslt.xsltFilepath)});
		}else{
			if(xslts && xslts instanceof Array && xslts.length > 0)
				this.onChangeValue({name:"xsltPath", value:(xslts[xslts.length-1].xsltFilepath)});
			else
				this.onChangeValue({name:"xsltPath", value:null});
		}
	}

	isManual(manual){
		this.setState({manual});
	}

	setPaymentInfo(paymentInfo) {
		let data = deepCopyObject(this.state.data);
		data["paymentInfo"]["paymentMeansCode"] = paymentInfo.paymentMeansCode;
		data["paymentInfo"]["paymentChannelCode"] = paymentInfo.paymentChannelCode;
		data["paymentInfo"]["payerFinancialAccountId"] = paymentInfo.payerFinancialAccountId;
		data["paymentInfo"]["payeeFinancialAccountId"] = paymentInfo.payeeFinancialAccountId;
		data["paymentInfo"]["instructionNote"] = paymentInfo.instructionNote;
		data["paymentInfo"]["paymentFormattedName"] = paymentInfo.paymentFormattedName;
		data["paymentInfo"]["paymentVkn"] = paymentInfo.paymentVkn;
		data["paymentInfo"]["paymentCity"] = paymentInfo.paymentCity;
		data["paymentInfo"]["paymentCountry"] = paymentInfo.paymentCountry;
		data["paymentInfo"]["paymentDueDate"] = paymentInfo.paymentDueDate;
		data["paymentInfo"]["payeeFinancialInstitution"] = paymentInfo.payeeFinancialInstitution;
		data["paymentInfo"]["payerFinancialInstitution"] = paymentInfo.payerFinancialInstitution;
		this.setState({data});
	}

	clearPaymentInfo() {
		let data = deepCopyObject(this.state.data);
		data["paymentInfo"]["paymentMeansCode"] = null;
		data["paymentInfo"]["paymentChannelCode"] = null;
		data["paymentInfo"]["paymentFinancialAccountId"] = null;
		data["paymentInfo"]["instructionNote"] = null;
		data["paymentInfo"]["paymentFormattedName"] = null;
		data["paymentInfo"]["paymentVkn"] = null;
		data["paymentInfo"]["paymentCity"] = null;
		data["paymentInfo"]["paymentCitySubdivision"] = null;
		data["paymentInfo"]["paymentCountry"] = null;
		data["paymentInfo"]["paymentDueDate"] = null;
		data["paymentInfo"]["payerFinancialInstitution"] = null;
		data["paymentInfo"]["payeeFinancialInstitution"] = null;
		this.setState({data});
	}

	isKamu() {
		return false;
	}

	setAdditionalDocument(additionalDocument) {
		let data = deepCopyObject(this.state.data);
		data['exchangeAdditionalDocuments'] = additionalDocument;
		this.setState({data});
	}

	changeKDV(name, value) {
		let data = deepCopyObject(this.state.data);
		data[name] = value;
		this.setState({data});
	}

	setDocExternalCustomer = (docExternalCustomer) => {
		let data = deepCopyObject(this.state.data);
		data["trdDocExternalCustomer"] = docExternalCustomer;
		this.setState({data});
	}
	render() {
		let layout = {
			background: 'rgba(255,255,255,0.82)',
			color: '#3e3636',
			fontSize: '12px'
		};
		if (!this.state.data)
			return (<ReactLoadingTop style={{width:"90px", height: "90px"}} />);
		return (
			<div className="row baseBackground">
				{!this.state.data.deletedAt &&
					<NavBarKS offsetWidth={this.props.offsetWidth} innerWidth={window.innerWidth} name={"createEditVoucher"}>

						<StickButton position="leftSide"
									 title="Yeni"
									 label={this.state.saveType === "new" && this.state.saveLoading ? "Oluşturuluyor..." : "Yeni"}
									 disabled={this.state.saveLoading}
									 className="stickButton plus-circle"
									 icon='plus-circle'
									 style={{marginRight: '2px'}}
									 onClick={(e) => this.onClickSave(e, "new")}/>

						<StickButton position="leftSide"
									 title="Goster"
									 label={this.state.saveType === "Goster" && this.state.saveLoading ? "Oluşturuluyor..." : "Makbuzu Göster"}
									 disabled={this.state.saveLoading}
									 className="stickButton observe"
									 icon='observe'
									 style={{marginRight: '2px'}}
									 onClick={(e) => this.onClickSave(e, "look")}/>

						<StickButton position="leftSide"
									 title="Direkt Gönder"
									 label={this.state.saveType === "directSend" && this.state.saveLoading ? "Gönderiliyor..." : "Direkt Gönder"}
									 disabled={this.state.saveLoading}
									 className="stickButton send"
									 icon='send'
									 onClick={(e) => this.onClickSave(e, "directSend")} />

						<StickButton position="rightSide"
									 title="Kaydet"
									 label={this.state.saveType === "save" && this.state.saveLoading ? "Kaydediliyor..." : "Kaydet"}
									 disabled={this.state.saveLoading}
									 className="stickButton save"
									 icon='save'
									 onClick={(e) => this.onClickSave(e, "save")}/>

						<StickButton position="rightSide"
									 title="Kaydet & Kapat"
									 label={this.state.saveType === "saveClose" && this.state.saveLoading ? "Kaydediliyor..." : "Kaydet & Kapat"}
									 disabled={this.state.saveLoading}
									 className="stickButton terminate"
									 icon='terminate'
									 onClick={(e) => this.onClickSave(e, "saveClose")}/>
					</NavBarKS>
				}

				{this.state.data.deletedAt &&
					<NavBarKS offsetWidth={this.props.offsetWidth} innerWidth={window.innerWidth}>
						<StickButton position="rightSide" title="Kaydet & Gönder" label={this.state.saveType === "saveSend" && this.state.saveLoading ? "Gönderiliyor..." : "Kaydet & Gönder"}
									 disabled={this.state.saveLoading} className="zocial Gonder" onClick={(e) => this.onClickSave(e, "saveSend")} />
					</NavBarKS>
				}

				{this.state.mediaModal &&
				<MediaViewer modal={this.state.mediaModal}
							 url={this.state.url}
							 title={this.state.title}
							 listener={this.setMediaViewer}
				/>
				}
				{this.state.showSendSwal &&
				<DefaultModal
					disabled={this.state.sendBtnDisabled}
					isOpen={this.state.showSendSwal}
					title={"Kullanmak İstediğiniz Öneki Seçiniz"}
					confirmBtnText="Gönder"
					cancelBtnText="İptal"
					onConfirm={this.confirmSend}
					onCancel={(e) => this.setState({showSendSwal: false})}
				>
					<div className="col-sm-12">
						<h5 style={{
							fontFamily: 'Century Gothic',
							fontSize: '1em',
							fontWeight: 100,
							textAlign: "center"
						}}
							className="text-danger">{this.state.documentId}</h5>
					</div>
					<div className="col-sm-12">
						<Select
							value={this.state.documentId}
							clearable={false}
							placeholder="Seçiniz..."
							noResultsText="Kayıt bulunamadı."
							onChange={(e) => this.setState({documentId: e.value, lastIssueDate: e.lastIssueDate})}
							options={this.state.prefixCodes.map(prefixCode => ({
								value: prefixCode.value,
								label: prefixCode.label,
								lastIssueDate: prefixCode.lastIssueDate
							}))}
						/>
					</div>
					{(showSmmRepeatDay(this.props.match.params.type)) &&
						<div className="col-sm-12 row">
							<label className="col-sm-3 col-form-label" style={{whiteSpace: "nowrap", marginLeft:0}}>Aylık Tekrarlansın</label>
							<div className="col-sm-1">
								<div className="form-group"
									 style={{paddingTop: "8px"}}>
									<input type="checkbox"
										   checked={this.state.repeat}
										   style={{float: "right"}}
										   onChange={(e) => e && this.setState({repeat:e.target.checked})}/>
								</div>
							</div>
							<div className="col-sm-8"></div>
						</div>
					}
				</DefaultModal>
				}
				<div className="col-sm-12 satirBasi">
					<div className="row card-header">
						<h4 className="baslik card-title">{this.props.match.params.type === "MM" ?"Müstahsil Makbuzu" :
							(this.props.match.params.type === "SMM" ? "Serbest Meslek Makbuzu" : "Döviz Makbuzu")} </h4>
					</div>
					<div className="">
						<div className="headerTextStyle ettn" style={{paddingBottom:'25px', fontSize: '0.9em'}}>
							<div className="col-sm-6 col-lg-6 row"> ETTN : {this.state.data.documentUuid}</div>
						</div>
					</div>
					<div className="col-sm-12">
						<div className="row baseDashboard">
							<div className="col-sm-7">
								<div className="card-header">
									<div className="row" style={{marginLeft:"-30px", marginRight: "-75px"}}>
										<div className="col-sm-3">
										<h4 className="card-title">{this.props.match.params.type === "MM" ? "Müstahsilin Bilgileri" :
											(this.props.match.params.type === "EXCHANGE" ? "Müşteri Bilgileri" :(this.state.data.hasForeignCustomer ? "Yabancı Alıcı Bilgileri" : "Alıcı Bilgileri"))}</h4>
										</div>
										<div className="col-sm-8 row">
											{this.props.match.params.type === "SMM" &&

												<div className="col-sm-4">
													<label style={{whiteSpace: "nowrap"}}>Yabancı Müşteri</label>
													<input type="checkbox"
														   checked={this.state.data.hasForeignCustomer}
														   style={{float: "right"}}
														   disabled={this.state.data.retailCustomer}
														   onChange={(e) => e && this.onChangeValue({
															   name: "hasForeignCustomer",
															   value: e.target.checked
														   })}/>
												</div>
											}
											{[EntegratorIdentifiers.MBT, EntegratorIdentifiers.SMART, EntegratorIdentifiers.KOLAYSOFT, EntegratorIdentifiers.MIKROKOM].includes(EntegratorConf.identifier)
												&& this.props.match.params.type === "SMM" &&
												<div className="col-sm-4">
													<label style={{whiteSpace: "nowrap"}}>{["mikrokom"].includes(VirtualHost.conf.resourcePrefix) ? " Parakende Müşteri" :"Şahıs Fatura"}</label>
													<input type="checkbox"
														   checked={this.state.data.retailCustomer}
														   disabled={this.state.data.hasForeignCustomer}
														   style={{float: "right"}}
														   onChange={(e) => e && this.onChangeValue({
															   name: "retailCustomer",
															   value: e.target.checked
														   })}/>
												</div>
											}
										</div>
									</div>
								</div>
								<div className="col-sm-12">
									{ !this.state.data.hasForeignCustomer && this.state.data.from!=="CONNECTOR" && !this.state.data.retailCustomer &&
										<div className="card-body" style={{marginLeft: '-30px', marginRight: '-75px'}}>
											<ExternalCustomer listener={this.setExternalCustomer}
															  requiredTaxOffice={false}
															  errorListener={this.errorListener}
															  checkGibUser={this.props.match.params.type === "SMM"}
															  error={this.state.error}
															  title={this.props.match.params.type === "MM" ? "Müstahsilin Bilgileri" : (this.props.match.params.type === "EXCHANGE" ? "Müşteri Bilgileri" : "Alıcı Bilgileri")}
															  cities={this.state.cities}
															  includeForeign={false}
															  docType={this.props.match.params.type}
															  invoiceTypeCode={this.state.data.invoiceTypeCode}
															  externalCustomer={this.state.data.externalCustomer}
															  countries={this.state.countries}
															  externalCustomerAddress={this.state.data.externalCustomerAddress}
															  currentUser = {this.props.currentUser}
											/>
										</div>
									}
									{this.state.data.from === "CONNECTOR" && (
										<ConnectorExternalCustomer
											listener={this.setConnectorExternalCustomer}
											cities={this.state.cities}
											countries={this.state.countries}
											externalCustomer={this.state.data.tmpDocConnectorExCustomer}
											docType={this.state.data.profileId}
										/>
									)}
									{(this.props.match.params.type === "SMM" && this.state.data.hasForeignCustomer) &&
									<ForeignCompanyInfo
										listener={this.setExternalCustomer}
										errorListener={this.errorListener}
										error={this.state.error}
										cities={this.state.cities}
										includeForeign={false}
										countries={this.state.countries}
										externalCustomer={this.state.data.externalCustomer}
										externalCustomerAddress={this.state.data.externalCustomerAddress}/>
									}
									{this.props.match.params.type === "SMM" && this.state.data.from !== "CONNECTOR" &&  this.state.data.retailCustomer &&
										<NoIdentifier
											{...this.props}
											docExternalCustomer={this.state.data.trdDocExternalCustomer}
											listener={this.setDocExternalCustomer}
											countries={this.state.countries}
											cities={this.state.cities}
										/>
									}
								</div>
							</div>
							<hr></hr>
							<div className="col-sm-5 row">
								<div className="card-header">
									<h4 className="card-title">{this.props.match.params.type === "MM" ? "Müstahsil Bilgileri" : "Makbuz Bilgileri"}</h4>
								</div>
								<div className="col-sm-12 row">
									<div className="card-body">
										{this.props.match.params.direction !== "Tmp" &&
											<div className="row">
												<label className="col-sm-4 col-lg-6 col-form-label">Belge Numarası *</label>
												<div className="col-sm-8 col-lg-6">
													<div className="form-group">
														<input className="form-control" disabled type="text" name="documentId"
															   value={this.state.data.documentId}/>
													</div>
												</div>
											</div>
										}
										<div className="row">
											<label className="col-sm-4 col-lg-6 col-form-label">Gönderim Şekli *</label>
											<div className="col-sm-8 col-lg-6">
												<div className={"form-group" + this.validateClass('sendingType')}>
													<Select
														id="sendingType"
														clearable={false}
														placeholder="Seçiniz..."
														noResultsText="Kayıt bulunamadı."
														value={this.state.data.sendingType === null ? undefined : this.state.data.sendingType}
														onBlur={() => this.validateField({
															target: {
																id: "sendingType",
																dataset: {'vlength': "1,45"},
																value: this.state.data.sendingType
															}
														})}
														options={[
															{label:"Kağıt", value:"KAGIT"},
															{label:"Elektronik", value:"ELEKTRONIK"}
														]}
														onChange={(e) => e && this.onChangeValue({
															name: "sendingType",
															value: e.value
														})}
													/>
													{this.validateMessage('sendingType') !== "" &&
													<UncontrolledTooltip placement="right" target="sendingType" delay={0}>
														{this.validateMessage("sendingType")}
													</UncontrolledTooltip>}
												</div>
											</div>
										</div>

										{this.props.match.params.type=== "EXCHANGE" &&
											<div className="row">
											<label className="col-sm-4 col-lg-6 col-form-label">Belge Türü *</label>
											<div className="col-sm-8 col-lg-6">
												<div className={"form-group" + this.validateClass('typeCode')}>
													<Select
														id="typeCode"
														clearable={false}
														placeholder="Seçiniz..."
														noResultsText="Kayıt bulunamadı."
														value={this.state.data.documentTypeCode === null ? undefined : this.state.data.documentTypeCode}
														options={[
															{label: "Döviz Alım Belgesi", value: "DOVIZALIMBELGESI"},
															{label: "Döviz Satım Belgesi", value: "DOVIZSATIMBELGESI"},
															{label: "e-Kıymetli Maden Alım Belgesi", value: "EKIYMETLIMADENALIMBELGESI"},
															{label: "e-Kıymetli Maden Satım Belgesi", value: "EKIYMETLIMADENSATIMBELGESI"}
														]}
														onChange={(e) => e && this.onChangeValue({
															name: "documentTypeCode",
															value: e.value
														})}
													/>
													{this.validateMessage('typeCode') !== "" &&
													<UncontrolledTooltip placement="right" target="typeCode"
																		 delay={0}>
														{this.validateMessage("typeCode")}
													</UncontrolledTooltip>}
												</div>
											</div>
										</div>}
										<div className="row">
											<label className="col-sm-4 col-lg-6 col-form-label">Düzenlenme Tarihi *</label>
											<div className="col-sm-8 col-lg-6">
												<div className={"form-group" + this.validateClass('issueDate')}>
													<Datetime locale="tr"
															  className="datepicker"
															  input={true}
															  inputProps={{id: 'issueDate'}}
															  closeOnSelect={true}
															  value={moment(this.state.data.issueDate)}
															  defaultValue={moment()}
															  dateFormat="DD-MM-YYYY"
															  timeFormat={false}
															  isValidDate={function (current) {
																  return current.isBefore(Datetime.moment());
															  }}
															  onChange={(e) =>
																  this.onChangeDateAndCurrency(e, "date",this.state.data.documentCurrencyCode,this.state.forexType)}/>
													{this.validateMessage('issueDate') !== "" &&
													<UncontrolledTooltip placement="right" target="issueDate" delay={0}>
														{this.validateMessage("issueDate")}
													</UncontrolledTooltip>}
												</div>
											</div>
										</div>
										<div className="row">
											<label className="col-sm-4 col-lg-6 col-form-label">Düzenlenme Saati *</label>
											<div className="col-sm-8 col-lg-6">
												<div className={"form-group" + this.validateClass('issueTime')}>
													<Datetime locale="tr"
															  className="timepicker"
															  inputProps={{id: 'issueTime'}}
															  input={true}
															  value={moment(this.state.data.issueDate)}
															  defaultValue={moment()}
															  dateFormat={false} timeFormat={true}
															  onChange={(e) => this.onChangeDate(e, "time")}/>
													{this.validateMessage('issueTime') !== "" &&
													<UncontrolledTooltip placement="right" target="issueTime" delay={0}>
														{this.validateMessage("issueTime")}
													</UncontrolledTooltip>}
												</div>
											</div>
										</div>
										{this.props.match.params.type !== "EXCHANGE" &&
											<div className="row">
											<label className="col-sm-4 col-lg-6 col-form-label">Para Birimi*</label>
											<div
												className={"col-sm-" + (this.state.data.documentCurrencyCode === "TRY" ? "8" : "4") + "  col-lg-" + (this.state.data.documentCurrencyCode === "TRY" ? "6" : "4")}>
												<div className="form-group">
													<Select
														id="documentCurrencyCode"
														clearable={false}
														placeholder="Seçiniz..."
														noResultsText="Kayıt bulunamadı."
														value={this.state.data.documentCurrencyCode === null ? this.onChangeCurrency({value: "TRY"}, "ForexBuying") : this.state.data.documentCurrencyCode}
														style={{width: "100%"}}
														onChange={(e) => this.onChangeCurrency({value: e.value}, "ForexBuying")}
														onBlur={() => this.validateField({
															target: {
																id: "documentCurrencyCode",
																dataset: {'vlength': "1,45"},
																value: this.state.data.documentCurrencyCode
															}
														})}
														options={this.state.currencyCodes.map(currencyCode => ({
															value: currencyCode.shortCode,
															label: currencyCode.longCode
														}))}
													/>
												</div>
											</div>
											{
												this.state.data.documentCurrencyCode !== "TRY" &&
												<div className="col-sm-3 col-lg-2" style={{
													display: (this.state.data.documentCurrencyCode === "TRY" ? 'none' : ''),
													padding: '0px 0px 0px 1px'
												}}>
													<div className="dropdown">
														<button className="btn btn-secondary dropdown-toggle"
																type="button"
																style={{margin: 0, padding: "4px 9px"}}
																id="dropdownMenuButton"
																data-toggle="dropdown"
																aria-haspopup="true"
																aria-expanded="false">
															{this.state.forexType || "Alış"}
														</button>
														<div className="dropdown-menu"
															 aria-labelledby="dropdownMenuButton">
															<a className="dropdown-item"
															   onClick={(e) => this.onChange(e, "ForexBuying")}>Alış</a>
															<a className="dropdown-item"
															   onClick={(e) => this.onChange(e, "ForexSelling")}>Satış</a>
														</div>
													</div>
												</div>
											}
										</div>}
										{
											this.state.data.documentCurrencyCode !== "TRY" &&
											<div className="row">
												<label className="col-sm-4 col-lg-6  col-form-label">Kur Değeri *</label>
												<div className="col-sm-8 col-lg-6">
													<div className="form-group">
														<NumberFormat
															value={this.state.data.paymentExchangeRate}
															allowNegative={false}
															isNumericString={true}
															thousandSeparator={'.'}
															decimalSeparator={','}
															suffix={this.state.suffix}
															displayType="input"
															isAllowed={values => {
																return (values.value === "" ? false : true);
															}}
															placeholder="Kur Değeri"
															renderText={value => {
																value.replace(/\./g, ',')
															}}
															onValueChange={(e) => this.onChangeValue({
																name: 'paymentExchangeRate',
																value: e.value
															})}
															className="form-control"/>
													</div>
												</div>
											</div>
										}
										{this.props.match.params.direction === "Tmp" &&
										<div className="row">
											<label className="col-sm-4 col-lg-6 col-form-label" style={{whiteSpace: 'nowrap'}}>XSLT Dosyası:*</label>
											<div className="col-sm-8 col-lg-6">
												<div className={"form-group" + this.validateClass('xsltPath')}>
													<Select
														name="xsltPath"
														value={this.state.data.xsltPath ? this.state.data.xsltPath : this.getXSLT()}
														clearable={false}
														placeholder="Seçiniz..."
														noResultsText="Kayıt bulunamadı."
														onChange={(e) => e && this.onChangeValue({name:"xsltPath", value: e.value})}
														options={this.state.xslts.map(xslt => ({value: xslt.xsltFilepath, label: xslt.xsltFilename}))}
													/>
												</div>
											</div>
										</div>
										}
									</div>
								</div>
							</div>
						</div>
					</div>

					{this.props.match.params.type === "EXCHANGE" && this.state.paymentMeansCodes &&
					<div style={{marginTop: '10px'}}>
						<Accordion>
							<AccordionItem>
								<AccordionItemTitle id={'accordion-item-title-' + this.props.index + 1} style={layout}>
									<span style={{fontWeight: "bold", fontSize: '17px'}}>Ödeme Bilgileri  </span>
									<i style={{fontWeight: "bold", fontSize: '17px'}} className="fa fa-chevron-down"/>
								</AccordionItemTitle>
								<AccordionItemBody>
									<div className="col-sm-12" style={{marginTop: '15px', marginBottom: '15px'}}>
										<Payment
											key={"payment"}
											isManual={this.isManual}
											manual={this.state.manual}
											listener={this.setPaymentInfo}
											listenerClearPayment={this.clearPaymentInfo}
											paymentInfo={{
												paymentChannelCode: this.state.data.paymentInfo.paymentChannelCode,
												paymentMeansCode: this.state.data.paymentInfo.paymentMeansCode,
												paymentFinancialAccountId: this.state.data.paymentInfo.paymentFinancialAccountId,
												payerFinancialAccountId: this.state.data.paymentInfo.payerFinancialAccountId,
												payeeFinancialAccountId: this.state.data.paymentInfo.payeeFinancialAccountId,
												instructionNote: this.state.data.paymentInfo.instructionNote,
												paymentFormattedName: this.state.data.paymentInfo.paymentFormattedName,
												paymentVkn: this.state.data.paymentInfo.paymentVkn,
												paymentCity: this.state.data.paymentInfo.paymentCity,
												paymentCountry: this.state.data.paymentInfo.paymentCountry,
												paymentDueDate: this.state.data.paymentInfo.paymentDueDate,
												payeeFinancialInstitution: this.state.data.paymentInfo.payeeFinancialInstitution,
												payerFinancialInstitution: this.state.data.paymentInfo.payerFinancialInstitution
											}}
											paymentMeansCodes={this.state.paymentMeansCodes}
											paymentChannelCodes={this.state.paymentChannelCodes}
											isKamu={this.isKamu}
											errorListener={this.errorListener}
											error={this.state.error}
											externalCustomer={this.state.externalCustomer}
											externalCustomerAddress={this.state.externalCustomerAddress}
											type={"voucher"}
										/>
									</div>
								</AccordionItemBody>
							</AccordionItem>
						</Accordion>
					</div>
					}

					{this.props.match.params.type === "EXCHANGE" && this.state.paymentMeansCodes &&
					<div style={{marginTop: '10px'}}>
						<Accordion>
							<AccordionItem>
								<AccordionItemTitle id={'accordion-item-title-' + this.props.index + 1} style={layout}>
									<span style={{fontWeight: "bold", fontSize: '17px'}}>Doküman Bilgileri  </span>
									<i style={{fontWeight: "bold", fontSize: '17px'}} className="fa fa-chevron-down"/>
								</AccordionItemTitle>
								<AccordionItemBody>
									<div className="col-sm-12" style={{marginTop: '15px', marginBottom: '15px'}}>
										<ExchangeDocumentInfo
											listener={this.setAdditionalDocument}
											additionalDocuments={this.state.data.exchangeAdditionalDocuments}
											countries={this.state.countries}/>
									</div>
								</AccordionItemBody>
							</AccordionItem>
						</Accordion>
					</div>
					}

					<div className="col-sm-12 baseDashboard" style={{marginTop:'10px'}}>
						<VoucherLines listener={this.setTrdDocVoucherLines}
									  manual={this.state.manual}
									  isManual={this.isManual}
									  errorListener={this.errorListener}
									  error={this.state.error}
									  suffix={this.state.suffix}
									  resourcePrefix={this.props.resourcePrefix}
									  documentCurrencyCode={this.state.data.documentCurrencyCode}
									  trdDocVoucherLines={this.state.data.trdDocVoucherLines}
									  charges={this.state.charges}
									  withholdingTypes={this.state.withholdingTypes}
									  stoppageTypes={this.state.stoppageTypes}
									  unitCodes={this.state.unitCodes}
									  currencyCodes={this.state.currencyCodes}
									  direction={this.props.match.params.direction}
									  docType={this.props.match.params.type}
									  barStandardVoucherContent={this.state.barStandardVoucherContent}
									  type={this.state.data.documentTypeCode}
						 			  date={this.state.data.issueDate}
									  changeDate={this.state.changeDate}
									  setChangeDate={this.setChangeDate}/>

					</div>
					<div className="col-sm-12" style={{marginTop:'10px'}}>
						<div className=" row baseDashboard">
							<div className="col-sm-7">
								<div className="card-header">
									<h4 className="card-title">Açıklama</h4>
								</div>
								<div className="card-body">
									<NoteList listener={this.setTrdDocVoucherNotes}
											  errorListener={this.errorListener}
											  manual={this.state.manual}
											  isManual={this.isManual}
											  error={this.state.error}
											  notes={this.state.data.trdDocVoucherNotes}
											  type="SMM"
									/>
								</div>
							</div>
							<hr></hr>
							<div className="col-sm-5 row">
								<div className="card-header">
									<h4 className="card-title">Toplamlar</h4>
								</div>
								<div className="col-sm-12">
									<div className="card-body">
											<TotalList suffix={this.state.suffix}
													   chargesName={"trdDocVoucherLineCharges"}
													   lines={this.state.data.trdDocVoucherLines}
													   totalKdv0Amount={this.state.data.totalKdv0Amount}
													   totalKdv1Amount={this.state.data.totalKdv1Amount}
													   totalKdv8Amount={this.state.data.totalKdv8Amount}
													   totalKdv10Amount={this.state.data.totalKdv10Amount}
													   totalKdv18Amount={this.state.data.totalKdv18Amount}
													   totalKdv20Amount={this.state.data.totalKdv20Amount}
													   isManual={this.state.data.isManual}
													   changeKDV={this.changeKDV}
													   showKDV={this.props.match.params.type==="SMM"}
													   showGVS={true}
													   showKDVT={this.props.match.params.type==="SMM"}
													   showNet={this.props.match.params.type==="SMM"}
													   lineExtensionAmount={this.state.data.lineExtensionAmount}
													   taxExclusiveAmount={this.state.data.taxExclusiveAmount}
													   taxInclusiveAmount={this.state.data.taxInclusiveAmount}
													   showATA={false}
													   type="voucher"
													   payableAmount={this.state.data.payableAmount}
													   barStandardVoucherContent={this.state.barStandardVoucherContent} />
										</div>
									</div>
								</div>
						</div>
					</div>
				</div>
				{this.state.saveLoading && <ReactLoadingTop style={{width: '90px', height: '90px'}}/>}
			</div>
		);
	}
}

export default CreateEditVoucher;